import { useMapInfoDataSelector } from '~/store/mapInfo/mapInfo.selectors';
import { usePublicMapSettingsAllowedExportDataToolsSelector } from '~/store/mapSettings/publicMapSettings/mapSettingsPublicMapSettings.selectors';
import {
  useIsMapPresentationalSelector, useIsReadOnlyMapSelector,
} from '~/store/selectors/useMapInfoSelectors';
import { hasFeatureOrToolAllowedPresentationalMapExport } from './mapToolsAndFeatures.helpers';
import type { ToolOrFeatureWithDataExport } from './toolsAndFeaturesWithDataExport.types';

export const useIsDataExportAllowed = (mapTool: ToolOrFeatureWithDataExport) => {
  const allowedPresentationalMapTools = usePublicMapSettingsAllowedExportDataToolsSelector();
  const isMapPresentational = useIsMapPresentationalSelector();
  const mapInfo = useMapInfoDataSelector();
  const isReadOnlyMap = useIsReadOnlyMapSelector();

  return (!isMapPresentational && !isReadOnlyMap) || (isMapPresentational && hasFeatureOrToolAllowedPresentationalMapExport(
    mapTool,
    allowedPresentationalMapTools,
    mapInfo,
  ));
};
